import { render, staticRenderFns } from "./StatementItemDetails.vue?vue&type=template&id=024c9818&scoped=true&"
import script from "./StatementItemDetails.vue?vue&type=script&lang=ts&"
export * from "./StatementItemDetails.vue?vue&type=script&lang=ts&"
import style0 from "./StatementItemDetails.vue?vue&type=style&index=0&id=024c9818&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024c9818",
  null
  
)

export default component.exports